// Online Store ID - Indication that application is on server side
export const ONLINE_STORE_ID = '8119';
export const B2B = 'b2b';

export const PROJECTS_CRUMB = {
  label: 'Projects',
  url: '/projects',
};
export const ACCOUNT_DASHBOARD = '/myaccount/dashboard';

export const UNAUTHORIZED_SVOCID_PROJECT_DETAILS = 'No projects exist for this svoc id';
